


























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Report, SearchCondition } from '@/modules/report';
import { Account } from '@/modules/me';
import { PublicTypes, getPublicTypeName } from '@/enums/publicTypes';
import { ReadTypes } from '@/enums/readTypes';
import { UserTypes } from '@/enums/userTypes';

@Component
export default class LatelyReport extends Vue {
  private PublicTypes = PublicTypes;
  private getPublicTypeName = getPublicTypeName;

  @Prop({ default: '' }) private studentId!: string;
  @Prop({ default: 7 }) private days: number;

  private reports: Report[] = [];
  private loading = false;

  private condition: SearchCondition = this.studentId ? {
    dateFrom: (this as any).$moment().add(-7, 'days'),
    dateTo: null,
    publicType: PublicTypes.All,
    readType: ReadTypes.All,
    studentId: this.studentId,
    tutorIdList: [],
    keyWord: '',
    perPage: 1000000,
    page: 1,
    sort: 'updateDate descending',
  } : {
    dateFrom: (this as any).$moment().add(-7, 'days'),
    dateTo: null,
    publicType: PublicTypes.All,
    readType: ReadTypes.All,
    studentId: '',
    tutorIdList: [],
    keyWord: '',
    perPage: 1000000,
    page: 1,
    sort: 'recentlyadmintutor',
  };

  get user(): Account {
    return this.$store.state.me.user;
  }

  get userId() {
    if (this.user === null) {
      return null;
    } else {
      return this.user.id;
    }
  }

  @Watch('user')
  private changeUserId() {
    this.loadData();
  }

  private created() {
    this.condition.dateFrom = (this as any).$moment().add(-this.days, 'days');
  }

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    if (!this.userId) {
      this.reports = [];
      return;
    }

    if (!!this.user) {
      if (this.user.authority === UserTypes.Admin ||
          this.user.authority === UserTypes.Owner ||
          this.user.authority === UserTypes.AdminTutor) {
        this.condition.tutorIdList = [];
        this.condition.sort = 'recentlyadmintutor';
      } else {
        this.condition.tutorIdList = [this.userId as string];
        this.condition.sort = 'recentlytutor';
      }
    }

    this.loading = true;

    const data = await this.$store.dispatch(
      'report/getReports',
      this.condition
    ).catch((error) => {
      this.reports = [];
      this.loading = false;
      return;
    });
    this.reports = data.reportList;
    this.loading = false;
  }

  private lessonDateFormatter(report: Report) {
    const moment = (this as any).$moment;
    if (!report.lessonStartDate) {
      return '';
    }
    let start: string;
    if (report.lessonStartDate.getHours() === 0 && report.lessonStartDate.getMinutes() === 0) {
      start = moment(report.lessonStartDate).format('YYYY/MM/DD');
    } else {
      start = moment(report.lessonStartDate).format('YYYY/MM/DD H:mm');
    }
    if (!report.lessonEndDate) {
      return start;
    } else {
      if (report.lessonEndDate.getHours() === 0 && report.lessonEndDate.getMinutes() === 0) {
        return `${start} ～ ${moment(report.lessonEndDate).format('YYYY/MM/DD')}`;
      } else {
        return `${start} ～ ${moment(report.lessonEndDate).format('YYYY/MM/DD H:mm')}`;
      }
    }
  }

  private onReportClick(report: Report) {
    this.$router.push({
      name: 'ReportDetails',
      params: {
        reportId: report.id
      }
    });
  }

  private onMoreClick() {
    const condition: SearchCondition = JSON.parse(JSON.stringify(this.condition));
    condition.dateFrom = null;
    condition.dateTo = null;
    this.$router.push({
      name: 'ReportList',
      params: {
        searchCondition: JSON.stringify(condition)
      }
    });
  }
}
